import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { LocationNameState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/location-name";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useState } from "react";

export const LocationNameDetails = memo(function LocationNameDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<LocationNameState>) {
  const [inputValue, setInputValue] = useState("");

  return (
    <Flex dir="column" gap="md">
      <RedoTagInputField
        delimiters={["newline"]}
        description="Press enter to add a location name (case sensitive)"
        inputValue={inputValue}
        label="Origin location names"
        placeholder="Type location name and press enter"
        setInputValue={setInputValue}
        setTags={(names) => setState({ names })}
        state={disabled ? "disabled" : "default"}
        tags={state.names.map((name) => ({ text: name, color: "gray" }))}
      />
    </Flex>
  );
});
